/*
 * P2: what the recovery cards add to the login card (`LoginForm.module.css`): the v3 `.auth-ok`
 * outcome block with its `.state-ic` circle, the `.btn-link` next to the password label, and the
 * field's `.err-text`.
 */
.ok {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  text-align: center;
}

.stateIcon {
  display: grid;
  place-items: center;
  inline-size: 40px;
  block-size: 40px;
  margin-block-end: var(--space-2);
  border-radius: 50%;
  background: var(--surface-sunken);
  color: var(--text-muted);
}

.stateIconError {
  background: var(--danger-surface);
  color: var(--danger-text);
}

/* The label row of the password: the link sits at its end, where it is looked for when it fails. */
.passwordRow {
  position: relative;
}

.forgot {
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
  color: var(--action-text);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
}

.forgot:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.fieldError {
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-12);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
